import React from 'react'

const P = ({ children }) => <p className="roboto-regular p-3 white">{children}</p>

export default P
